module.exports = __webpack_public_path__ + "static/stillGIF-c81bcfac00e6a73c400389a272b3a7ee.png";